import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SERVICES_LIST, IMG } from "@/lib/brand";
import { Section, PageHeader } from "@/components/common";

export default function Services() {
  return (
    <div data-testid="services-page">
      <PageHeader eyebrow="Services" title="Nos services" subtitle="De la création à la diffusion, un accompagnement global pour vos projets musicaux, sonores et audiovisuels." image={IMG.gear} />
      <Section className="py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES_LIST.map((s) => (
            <Link key={s.key} to={`/services/${s.key}`} data-testid={`service-card-${s.key}`} className="card-dark p-7 group">
              <h3 className="font-display font-bold text-xl">{s.title}</h3>
              <p className="text-slate-400 text-sm mt-3 leading-relaxed">{s.desc}</p>
              <div className="mt-5 text-gold text-xs font-semibold flex items-center gap-1">En savoir plus <ArrowRight size={13} className="group-hover:translate-x-1 transition" /></div>
            </Link>
          ))}
        </div>
      </Section>
    </div>
  );
}
